(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Sistem Blog — blog.min.js
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("BlogBanner", function () { DNB.BlogBanner.init(); });
    DNB.safeInit("BlogList", function () { DNB.BlogList.init(); });
  });
})(window, document);
